import { jsx as _jsx } from "react/jsx-runtime";
const VARIANTS = {
    primary: {
        primary: 'text-green-600 bg-transparent outline-green before:bg-green hover:outline-green group-hover:outline-green hover:text-white group-hover:text-white',
        inverse: 'text-green-600 bg-transparent outline-green before:bg-green hover:outline-green group-hover:outline-green hover:text-white group-hover:text-white'
    },
    secondary: {
        primary: 'text-white bg-gold-600 outline-gold-600 before:bg-green hover:outline-green group-hover:outline-green hover:text-white group-hover:text-white',
        inverse: 'text-grey-400 outline-grey-100 bg-grey-100 before:bg-green hover:outline-green group-hover:outline-green hover:text-white group-hover:text-white'
    },
    grey: {
        primary: 'text-grey-400 outline-grey-100 bg-grey-100 before:bg-green hover:outline-green group-hover:outline-green hover:text-white group-hover:text-white',
        inverse: 'text-white bg-gold-600 outline-gold-600 before:bg-green hover:outline-green group-hover:outline-green hover:text-white group-hover:text-white',
    },
    text: {
        primary: 'text-green-600 hover:text-green-700 focus:text-green-700',
        inverse: 'text-green-600 hover:text-green-700 focus:text-green-700',
    },
    'no-underline': {
        primary: 'text-green-600 hover:text-green-700 focus:text-green-700',
        inverse: 'text-green-600 hover:text-green-700 focus:text-green-700',
    },
};
const variantToClasses = (variant, invert) => {
    const colors = VARIANTS[variant];
    const classes = [];
    if (invert)
        classes.push(colors.inverse);
    else
        classes.push(colors.primary);
    return classes;
};
const Button = ({ type = 'button', variant = 'primary', onClick, invert = false, isDisabled = false, height, buttonRef, children }) => {
    const classes = [];
    if (variant === 'text' || variant === 'no-underline') {
        classes.push('text-link');
    }
    else {
        classes.push('button');
    }
    if (variant === 'no-underline')
        classes.push('no-underline');
    if (variant)
        classes.push(...variantToClasses(variant, invert));
    if (isDisabled)
        classes.push('is-disabled');
    if (height) {
        classes.push(height);
    }
    return (_jsx("button", { className: classes.join(' '), type: type, onClick: onClick, ref: buttonRef, children: _jsx("span", { className: "relative", children: children }) }));
};
export default Button;
